import { GOOGLE_AUTH } from "@/constants/endpoints.constant";
import { isGoogleAuth2ClientIdTokenResponse } from "@/utils/type-guards/authGoogleTypeGuard";

export const fetchIdToken = async (code: string): Promise<string> => {
  const fetchToken = await fetch(GOOGLE_AUTH, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({ code }),
  });

  const tokenId: unknown = await fetchToken.json();

  if (!isGoogleAuth2ClientIdTokenResponse(tokenId)) {
    throw new Error("Unexpected Google ID token response");
  }

  return tokenId.id_token;
};
